import type { OptimizationInput, Vehicle } from '../types/optimization'

type Combination = NonNullable<OptimizationInput['vehicleCombination']>

function axleValue(vehicle: Vehicle | null | undefined, field: 'kingPinPosition' | 'fifthWheelPosition' | 'fifthWheelMaxLoad') {
  const config = vehicle?.axle_configuration
  if (!config || typeof config !== 'object') return undefined
  const value = config[field]
  return typeof value === 'number' && Number.isFinite(value) ? value : undefined
}

/** Keep the saved combination aligned with the equipment edited in the session. */
export function synchronizeVehicleCombination(
  combination: Combination | undefined,
  vehicle: Vehicle | null | undefined,
  tractor: Vehicle | null | undefined,
): Combination | undefined {
  if (!combination || !vehicle || !tractor) return combination
  return {
    ...combination,
    trailerVehicleId: vehicle.id ?? combination.trailerVehicleId,
    tractorVehicleId: tractor.id ?? combination.tractorVehicleId,
    coupling: {
      ...combination.coupling,
      trailerKingPinPosition: axleValue(vehicle, 'kingPinPosition')
        ?? vehicle.fifth_wheel?.position ?? combination.coupling.trailerKingPinPosition,
      tractorFifthWheelPosition: axleValue(tractor, 'fifthWheelPosition')
        ?? tractor.fifth_wheel?.position ?? combination.coupling.tractorFifthWheelPosition,
      fifthWheelMaxLoad: axleValue(tractor, 'fifthWheelMaxLoad')
        ?? tractor.fifth_wheel?.maxLoad ?? combination.coupling.fifthWheelMaxLoad,
    },
  }
}
